import { default as yarDarkTheme } from '@homebot/yar/dist/web/js/Homebot--Dark.module.js'
import { default as yarLightTheme } from '@homebot/yar/dist/web/js/Homebot--Light.module.js'
import { default as yarAdminTheme } from '@homebot/yar/dist/web/js/Homebot--Admin.module.js'

const breakpoint = {
  md: '640px',
}

const fontFamily = {
  heading: 'Open sans',
  body: 'Open sans',
}

const fontWeight = {
  light: 300,
  regular: 400,
  semibold: 600,
  bold: 700,
}

const fontSize = {
  '0': { smallScreen: '0', largeScreen: '0' },
  '100': { smallScreen: '10px', largeScreen: '11px' },
  '200': { smallScreen: '12.5px', largeScreen: '14px' },
  '300': { smallScreen: '14px', largeScreen: '16px' },
  '400': { smallScreen: '15px', largeScreen: '17px' },
  '500': { smallScreen: '17px', largeScreen: '19px' },
  '600': { smallScreen: '21px', largeScreen: '24px' },
  '700': { smallScreen: '28px', largeScreen: '32px' },
  '800': { smallScreen: '34px', largeScreen: '38px' },
  '900': { smallScreen: '47px', largeScreen: '53px' },
  '1000': { smallScreen: '58px', largeScreen: '65px' },
  '1100': { smallScreen: '79px', largeScreen: '89px' },
  '1200': { smallScreen: '96px', largeScreen: '108px' },
}

const lineHeight = {
  '0': { smallScreen: '100%', largeScreen: '100%' },
  '100': { smallScreen: '160%', largeScreen: '160%' },
  '200': { smallScreen: '160%', largeScreen: '160%' },
  '300': { smallScreen: '142.9%', largeScreen: '142.9%' },
  '400': { smallScreen: '160%', largeScreen: '160%' },
  '500': { smallScreen: '141.2%', largeScreen: '141.2%' },
  '600': { smallScreen: '152.4%', largeScreen: '152.4%' },
  '700': { smallScreen: '142.9%', largeScreen: '142.9%' },
  '800': { smallScreen: '129.4%', largeScreen: '129.4%' },
  '900': { smallScreen: '102.1%', largeScreen: '102.1%' },
  '1000': { smallScreen: '117.2%', largeScreen: '117.2%' },
  '1100': { smallScreen: '121.5%', largeScreen: '121.5%' },
  '1200': { smallScreen: '125%', largeScreen: '125%' },
}

const letterSpacing = {
  '0': { smallScreen: '0em', largeScreen: '0em' },
  '100': { smallScreen: '0.012em', largeScreen: '0.012em' },
  '200': { smallScreen: '0em', largeScreen: '0em' },
  '300': { smallScreen: '-0.0014em', largeScreen: '-0.0014em' },
  '400': { smallScreen: '-0.002em', largeScreen: '-0.002em' },
  '500': { smallScreen: '-0.0026em', largeScreen: '-0.0026em' },
  '600': { smallScreen: '-0.001em', largeScreen: '-0.001em' },
  '700': { smallScreen: '-0.012em', largeScreen: '-0.012em' },
  '800': { smallScreen: '-0.015em', largeScreen: '-0.015em' },
  '900': { smallScreen: '-0.017em', largeScreen: '-0.017em' },
  '1000': { smallScreen: '-0.015em', largeScreen: '-0.015em' },
  '1100': { smallScreen: '-0.007em', largeScreen: '-0.007em' },
  '1200': { smallScreen: '-0.013em', largeScreen: '-0.013em' },
}

// sets for font sizes
const typography = {
  '0': {
    fontSize: fontSize['0'],
    lineHeight: lineHeight['0'],
    letterSpacing: letterSpacing['0'],
  },
  '100': {
    fontSize: fontSize['100'],
    lineHeight: lineHeight['100'],
    letterSpacing: letterSpacing['100'],
  },
  '200': {
    fontSize: fontSize['200'],
    lineHeight: lineHeight['200'],
    letterSpacing: letterSpacing['200'],
  },
  '300': {
    fontSize: fontSize['300'],
    lineHeight: lineHeight['300'],
    letterSpacing: letterSpacing['300'],
  },
  '400': {
    fontSize: fontSize['400'],
    lineHeight: lineHeight['400'],
    letterSpacing: letterSpacing['400'],
  },
  '500': {
    fontSize: fontSize['500'],
    lineHeight: lineHeight['500'],
    letterSpacing: letterSpacing['500'],
  },
  '600': {
    fontSize: fontSize['600'],
    lineHeight: lineHeight['600'],
    letterSpacing: letterSpacing['600'],
  },
  '700': {
    fontSize: fontSize['700'],
    lineHeight: lineHeight['700'],
    letterSpacing: letterSpacing['700'],
  },
  '800': {
    fontSize: fontSize['800'],
    lineHeight: lineHeight['800'],
    letterSpacing: letterSpacing['800'],
  },
  '900': {
    fontSize: fontSize['900'],
    lineHeight: lineHeight['900'],
    letterSpacing: letterSpacing['900'],
  },
  '1000': {
    fontSize: fontSize['1000'],
    lineHeight: lineHeight['1000'],
    letterSpacing: letterSpacing['1000'],
  },
  '1100': {
    fontSize: fontSize['1100'],
    lineHeight: lineHeight['1100'],
    letterSpacing: letterSpacing['1100'],
  },
  '1200': {
    fontSize: fontSize['1200'],
    lineHeight: lineHeight['1200'],
    letterSpacing: letterSpacing['1200'],
  },
}

const spacing = {
  '0': '0',
  '100': '1px',
  '200': '2px',
  '300': '4px',
  '400': '8px',
  '500': '16px',
  '600': '24px',
  '700': '28px',
  '800': '32px',
  '900': '48px',
  '1000': '72px',
  '1100': '96px',
  '1200': '128px',
  '1300': '144px',
  '1400': '168px',
}

// Temporary Theme
const tempTheme = {
  breakpoint,
  fontFamily,
  fontWeight,
  typography,
  spacing,
}

const darkTheme = { ...yarDarkTheme, ...tempTheme }

const lightTheme = { ...yarLightTheme, ...tempTheme }

const adminTheme = { ...yarAdminTheme, ...tempTheme }

export { darkTheme, lightTheme, adminTheme }
